// Invalid 
export const INVALID_MOBILE_NUMBER = 'Invalid Mobile Number.';
export const INVALID_DRIVING_LICENCE = 'Invalid Driving Licence.';
export const INVALID_BANK_ACC_NUMBER = 'Invalid Account No';
export const INVALID_BANK_IFSC = 'Invalid Bank IFSC Code.';
export const INVALID_PAN_NO = 'Invalid Pan No.';
export const INVALID_ADHAR_NO = 'Invalid Aadhar No.';
export const INVALID_RESIDENCE_ADDRESS = 'Invalid Resident Address';
export const INVALID_PERMENET_ADDRESS = 'Invalid Permenet Address';
export const INVALID_ALTERNET_NAME = 'Invalid Alternate Name';
export const INVALID_MOBILE_NO = 'Invalid Mobile No.';
export const INVALID_GUARANTOR_NAME = 'Invalid Guarantor Name';
export const INVALID_GUARANTOR_MOBILE_NO = 'Invalid Guarantor Mobile No.';
export const NO_SPACE = 'No Blank Space Require';
export const INVALID_NAME = 'Invalid Name';
export const INVALID_NUMBER = 'Invalid Number';
export const INVALID_EMAIL = 'Invalid Email';
export const INVALID_PINCODE = 'Invalid Pincode';
export const INVALID_AMMOUNT = 'Invalid Amount';
export const FIELD_IS_REQUIRED = 'Field is Required';
export const INVALID_GST_NO = 'Invalid GST No.';
export const INVALID_SPACE = 'Space is not allowed.';

// Min Validation
export const INVALID_DRIVER_NAME = 'Should be more than 3 characters';

export const INVALID_MESSAGES = {
    INVALID_MOBILE_NUMBER,
    INVALID_DRIVING_LICENCE,
    INVALID_BANK_ACC_NUMBER,
    INVALID_BANK_IFSC,
    INVALID_PAN_NO,
    INVALID_ADHAR_NO,
    INVALID_RESIDENCE_ADDRESS,
    INVALID_PERMENET_ADDRESS,
    INVALID_ALTERNET_NAME,
    INVALID_MOBILE_NO,
    INVALID_GUARANTOR_NAME,
    INVALID_GUARANTOR_MOBILE_NO,
    NO_SPACE,
    INVALID_NAME,
    INVALID_NUMBER,
    INVALID_EMAIL,
    INVALID_PINCODE,
    INVALID_AMMOUNT,
    INVALID_GST_NO,
    INVALID_SPACE,
    INVALID_DRIVER_NAME,
    IVALID_FILE: 'Invalid File',
    INVALID_FILE_FORMAT: 'Invalid File Format',
    INVALID_MAXIMUMSIZE: (len)=> `Maximum length is ${len}`,
    INVALID_FIELD : (field)=> `Invalid ${field}`

}

export const LOCAL_STORAGE = {
    userId: Number(localStorage.getItem("userId")),
    customerNo: Number(localStorage.getItem("customerNo")),
    userToken: localStorage.getItem('apiToken'),
    customerCompanyName: localStorage.getItem("customerCompanyName"),
    customerName: localStorage.getItem("customerName"),
    customerLogo: localStorage.getItem("customerLogo"),
}

export const EnableIntegratedReferenceNo = [1166, 1165, 1158, 1568].includes(Number(LOCAL_STORAGE.customerNo));
export const EnableIntegratedRefErrorContent = [1158, 1568].includes(Number(LOCAL_STORAGE.customerNo));
export const transworldCustomer = [1568].includes(Number(LOCAL_STORAGE.customerNo));
export const hasMinValueForBillDate = [1568].includes(Number(LOCAL_STORAGE.customerNo));

export const PROMPTS = {
    NO_RECORDS_FOUND: "No Record(s) Found",
    IMPORT_FAILED: 'Import Failed.',
    LOADING: 'Loading...',
    CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR : (field)=> `${field} can only be changed after the validity end date expired.`
}

export const DATE_FORMATS = {
    DD_MM_YYYY: 'DD-MM-YYYY',
    dd_MM_yyyy: 'dd-MM-yyyy',
    ddMMyyyy: 'dd/MM/yyyy',
    DDMMYYYHHmm : "DD-MM-YYYY | HH:mm",
    YYYY_MM_DD : 'YYYY-MM-DD'
}

export const REQUIRED_MESSAGES = {
    FIELD_IS_REQUIRED,
    START_DATE_REQUIRED: 'Start Date Required',
    END_DATE_REQUIRED: 'End Date Required',
    PARTNER_NAME: 'Partner Name is Required',
    PARTNER_CODE: 'Partner Code is Required',
    ADDRESS: 'Address is Required',
    PINCODE: 'Pincode is Required',
    PANNUMBER: 'Pan Number is Required',
    MAX_LENGTH : (no)=> `Maximum length is ${no}`
}

export const PO_TITLES = {
    MAPPED_PO : "Mapped Purchase Orders",
    UNMAPPED_PO : "UnMapped Purchase Orders"
}

export const PAYMENT_TITLES =  {
  PAYMENT_AMOUNT : " Payment Amount ",
  PAYMENT_DATE : "Payment Date ",
  PAYMENT_MODE : "Payment Mode ",
  SELECT_BACK : 'Select Bank',
  CHEEQUE_NO : "Cheque No",
  REF_NO : "Reference No ",
  TRANSACTION_DATE : "Transaction Date ",
  TDS_AMOUNT : "TDS Amount",
  FINAL_AMOUNT : "Final Amount"
}